import { render, staticRenderFns } from "./ShowType.vue?vue&type=template&id=2bc5ab37"
import script from "./ShowType.vue?vue&type=script&lang=js"
export * from "./ShowType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports